import { iconsAppData } from '../constants/icons';

class IconsService {
  private readonly icons: { [key: string]: JSX.Element } = {};

  constructor() {
    this.icons = iconsAppData;
  }

  getIcon(name: string): JSX.Element | null {
    return this.icons[name] || null;
  }
}

export const iconsService = new IconsService();
